import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import PageRoutes from "../Config/PageRoutes";

const ImportantConceptsMenu = () => {
    return (
        <Box className="sidebarButtonWrapper importantConceptsMenu">
            <Link to={PageRoutes.IMPORTANT_CONCEPTS}>
                <Box className="menuItem">
                    Important Concepts
                </Box>
            </Link>
        </Box>
    );
}

export default ImportantConceptsMenu;